import React, { Component } from "react";
import QRCode from "react-qr-code";
import dayjs from "dayjs";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  CircularProgress,
} from "@mui/material";
import { CheckCircle, Refresh } from "@mui/icons-material";
import ReactTable from "react-table";

const defaultFilterMethod = (filter, row) => {
  const cellValue = String(row[filter.id]).toLowerCase();
  return cellValue.includes(filter.value.toLowerCase());
};

class WhatsAppPage extends Component {
  constructor(props) {
    super(props);
    this.reactTable = React.createRef();
    this.state = {
      qrCodeData: "",
      status: "Checking...",
      loading: null,
      authenticated: false,
      boundNumber: null,
      tableData: [],
      polling: null,
    };

    this.tableColumns = [
      {
        Header: "Last Sync",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "last_sync",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        width: 200,
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.last_sync}
          </Typography>
        ),
      },
      {
        Header: "Phone Number",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "phone_number",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.phone_number}
          </Typography>
        ),
      },
      {
        Header: "Status",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "status",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            {e.original.status === "Connected" ? (
              <Typography
                component="span"
                variant="body2"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "#4CAF50",
                  fontWeight: "bold",
                }}
              >
                <CheckCircle sx={{ fontSize: 18, marginRight: 0.5 }} />
                {e.original.status}
              </Typography>
            ) : (
              <Typography
                component="span"
                variant="body2"
                sx={{
                  display: "inline-block",
                }}
              >
                {e.original.status}
              </Typography>
            )}
          </Box>
        ),
      },
    ];
  }

  componentDidMount() {
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  startPolling = () => {
    const polling = setInterval(this.fetchWhatsAppStatus, 5000);
    this.setState({ polling });
  };

  stopPolling = () => {
    if (this.state.polling) {
      clearInterval(this.state.polling);
      this.setState({ polling: null });
    }
  };

  fetchWhatsAppStatus = async () => {
    try {
      const response = await fetch("http://127.0.0.1:8989/status");
      const data = await response.json();

      if (data.authenticated) {
        const tableData = [
          {
            last_sync: dayjs().format("DD/MM/YYYY HH:mm:ss"),
            phone_number: data.boundNumber,
            status: "Connected",
          },
        ];
        this.setState({
          status: "Connected",
          authenticated: true,
          boundNumber: data.boundNumber,
          tableData,
        });
        this.stopPolling();
      } else if (data.loading && data.loading.percent > 0) {
        this.setState({
          status: `Loading... ${data.loading.percent}%`,
          loading: data.loading,
        });
      } else if (data.qr) {
        this.setState({
          qrCodeData: data.qr,
          status: "Use WhatsApp on your phone to scan the code",
        });
      } else {
        this.setState({ status: "Waiting for QR Code..." });
      }
    } catch (error) {
      console.error("Error fetching status:", error);
      this.setState({ status: "Error fetching status" });
    }
  };

  handleRefresh = () => {
    this.fetchWhatsAppStatus();
  };

  renderWhatsAppScan = () => {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#F0F2F5",
          padding: "16px",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "24px",
            maxWidth: "400px",
            width: "100%",
            bgcolor: "#FFFFFF",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
            WhatsApp Web
          </Typography>
          <Typography variant="body1" color="textSecondary" sx={{ mb: 2 }}>
            {this.state.status}
          </Typography>

          {this.state.loading && this.state.loading.percent > 0 && (
            <CircularProgress size={50} sx={{ mb: 2 }} />
          )}

          {this.state.qrCodeData && (
            <QRCode value={this.state.qrCodeData} size={200} />
          )}

          {/* {!this.state.authenticated && (
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleRefresh}
              sx={{ mt: 2 }}
            >
              Refresh QR Code
            </Button>
          )} */}
        </Paper>
      </Box>
    );
  };

  renderTable = () => {
    return (
      <Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Paper
                style={{
                  borderLeft: 6,
                  borderColor: "#2f55a2",
                  color: "#FFF",
                  maxHeight: 100,
                  padding: 16,
                  paddingBottom: 24,
                }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography
                      component="span"
                      variant="h1"
                      style={{
                        display: "inline",
                        fontSize: 20,
                        color: "#000",
                        fontWeight: "bold",
                      }}
                    >
                      WhatsApp Status
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <div className="contentDate">
                      <div style={{ marginRight: 0 }}>
                        <Button
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "#1273DE",
                          }}
                          startIcon={<Refresh />}
                          onClick={() => this.fetchWhatsAppStatus()}
                        >
                          <Typography
                            variant="button"
                            style={{
                              color: "#fff",
                              textTransform: "capitalize",
                            }}
                          >
                            Refresh
                          </Typography>
                        </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
        <br></br>
        <div className="box-container">
          <ReactTable
            ref={(r) => (this.reactTable = r)}
            data={this.state.tableData}
            columns={this.tableColumns}
            style={{ backgroundColor: "#f2f2f2" }}
            filterable
            defaultFilterMethod={defaultFilterMethod}
            defaultPageSize={500}
            showPageJump={false}
            showPageSizeOptions={false}
            showPagination={false}
          />
        </div>
      </Box>
    );
  };

  render() {
    return (
      <>
        {!this.state.authenticated
          ? this.renderWhatsAppScan()
          : this.renderTable()}
      </>
    );
  }
}

export default WhatsAppPage;
